export const MAX_2MB_FILE_SIZE = 2 * 1024 * 1024
export const MAX_4MB_FILE_SIZE = 4 * 1024 * 1024
